var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { alias, not } from '@ember/object/computed';
import { isNone } from '@ember/utils';
import EmberObject, { computed, notifyPropertyChange, set } from '@ember/object';
let ItemSubunitAssociation = (_dec = alias('item'), _dec2 = alias('enabled'), _dec3 = not('isEnabled'), _dec4 = alias('item.name'), _dec5 = alias('subunit.token'), _dec6 = computed('subunit.token', 'item.subunits.@each.token'), _dec7 = computed('item', 'unitToken'), (_class = class ItemSubunitAssociation extends EmberObject {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "content", _descriptor, this);
    _initializerDefineProperty(this, "isEnabled", _descriptor2, this);
    _initializerDefineProperty(this, "isEnabledOrder", _descriptor3, this);
    // sorts enabled before disabled
    _initializerDefineProperty(this, "name", _descriptor4, this);
    _initializerDefineProperty(this, "unitToken", _descriptor5, this);
  }
  get enabled() {
    const item = this.item;
    const subunitToken = this.subunit?.token;
    return item.enabledForUnit(subunitToken);
  }
  set enabled(value) {
    const item = this.item;
    const subunit = this.subunit;
    const subunitToken = subunit.get('token');
    if (value) {
      item.addMerchantSubunit(subunit);
      if (!isNone(item.addAffectedRelatedObjects)) {
        item.addAffectedRelatedObjects(subunitToken);
      }
    } else {
      if (!isNone(item.removeAffectedRelatedObjects)) {
        item.removeAffectedRelatedObjects(subunitToken);
      }
      item.removeMerchantSubunit(subunitToken);
    }
  }
  save() {
    return this.item.save();
  }
  set ordinal(val) {
    const unitToken = this.unitToken;
    this.item.setUnitOverride(unitToken, 'ordinal', val);
    set(this, 'item.isDirty', true);
    notifyPropertyChange(this, 'ordinal');
  }
  get ordinal() {
    return this.item.getUnitAttribute(this.unitToken, 'ordinal');
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "content", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isEnabled", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isEnabledOrder", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "unitToken", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "enabled", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "enabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "ordinal", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "ordinal"), _class.prototype)), _class));
export { ItemSubunitAssociation as default };